import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer np-admin-footer border-top bg-light">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 text-md-right">
              Powered by{" "}
              <a
                href="https://thinkershub.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="fw-bold text-decoration-none"
              >
                THINKERSHUB.IN
              </a>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}